if (!customElements.get('mm-product-form')) {
  customElements.define('mm-product-form', class MMProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = document.getElementById(`product-form-${this.dataset.section}${this.dataset.parent}`);
      if (!this.form) return;

      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.cartDrawer = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('.js-addToCart');
      if(!submitButton) return;

      if (submitButton.classList.contains('loading')) return;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`/cart/add.js`, config)
        .then((response) => response.json())
        .then(async(response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const cartRes = await fetch('/cart.js');
          const cartJSON = await cartRes.json();
          const { CartUpdateEvent } = await import('@theme/events');
          const event = new CartUpdateEvent(cartJSON, 'manual-trigger', {
            itemCount: cartJSON.item_count,
            source: 'featured-collection',
            sections: {}
          });

          document.dispatchEvent(event);

          if(this.cartDrawer && this.cartDrawer.open) {
            this.cartDrawer.open();
          } else if(this.cartDrawer) {
            this.cartDrawer.classList.add('active');
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}